module.exports = __webpack_public_path__ + "img/12.01d6458c.jpg";